import styled from 'styled-components';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

export const SModal = styled(Dialog)`
  .k-dialog {
    background-color: ${({ theme }) => theme.colors.primaryBackground};
    border-radius: 10px;
    box-shadow: 0px 10px 18px 0px rgba(157, 180, 190, 0.5);
    max-height: 98vh;
    max-width: 98vw;
    padding: 40px 40px 24px 40px;
  }

  .k-window-content,
  .k-actions {
    padding: 0;
    overflow: hidden;
  }

  .k-dialog-buttongroup {
    border-top: 0;
    display: flex;
    margin-top: 12px;
    position: relative;

    button {
      padding-left: 26px;
      padding-right: 26px;
    }
  }

  .close-button {
    cursor: pointer;
    position: absolute;
    right: 0;
  }
`;

export const ModalActionBar = styled(DialogActionsBar)`
  border-top: 0;
  display: flex;
  margin-top: 12px;

  button {
    padding-left: 26px;
    padding-right: 26px;
  }
`;

export const ModalResetPasswordSubmitContainer = styled.div`
  display: flex;
  justify-content: end;
  padding-top: 3em;
`;
